export default __webpack_public_path__ + "1d2134c34778fe62157a2dec8a86dad5.svg";